module.exports = __webpack_public_path__ + "img/01-Livepen-BT-PD02.cf41c5ab.png";